import { Dimensions, Platform } from 'react-native';
export default class ToastMobileViewStyle {
    constructor() {
        this.container = {
            display: "flex",
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            width: Dimensions.get('window').width,
            paddingTop: Platform.OS == "ios" ? 40 : 20,
            paddingBottom: 20,
            elevation: 1,
            zIndex: 1,
            paddingStart: 10,
            paddingEnd: 10
        };
    }
}
